import React from "react";
import { Card, Typography, Button } from "@ann/web-components";
import {
  EmptyStateWrapper,
  EmptyStateContent,
  CardWrapper,
  CTAWrapper,
  CTAButton,
  DescriptionText,
} from "./EmptyUsersList.styled";

const EmptyUsersList = ({ onInviteUsers }) => (
  <EmptyStateWrapper>
    <CardWrapper>
      <Card size="medium">
        <EmptyStateContent>
          <Typography category="title" size="small" weight="bold">
            No users yet
          </Typography>
          <DescriptionText category="body" size="medium" weight="regular">
            Add users individually or upload multiple at once. Then, you can organize them into teams and set permissions.
          </DescriptionText>
          <CTAWrapper>
            <CTAButton>
              <Button
                type="primary"
                size="medium"
                iconRight="personAdd"
                label="Invite Users"
                onClick={onInviteUsers}
              />
            </CTAButton>
          </CTAWrapper>
        </EmptyStateContent>
      </Card>
    </CardWrapper>
  </EmptyStateWrapper>
);

export default EmptyUsersList;

